import { render } from "./coach-wallet-modal.vue?vue&type=template&id=3d192ab8"
import script from "./coach-wallet-modal.vue?vue&type=script&lang=js"
export * from "./coach-wallet-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__